// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__k2b5z","active":"Categories_active__2nVv6"};